var default_styles_default = {
  "button_container": "VLj07",
  "button_margin": "pafWz",
  "button_text": "q1-qh",
  "button_size_content": "I0ywH"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
